/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'



const basePath = '/service-types'

const ServiceTypeEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
  ({
    fetchServiceTypes: builder.query<any, any>({
      query: () => `${basePath}`,
      providesTags:['service-types']
    }),

    createServiceType: builder.mutation<any, any>({
      query: (body) => ({
        url: `${basePath}`,
        method: 'post',
        body,
      }),
      invalidatesTags: ['service-types']
    }),
  })

export default ServiceTypeEndpoints
